import { create } from "zustand";
import { getAttandance, getLeave, getCheckInStatus, userCheckedInOut, approveOrRejectLeave, getLeaveApprovals, getTeamAndRm } from "../api";

export const useAttendancePageState = create((set) => ({
  attendanceData: {
    "plannedLeaves": [

    ],
    "unplannedLeaves": [

    ],
    "shrinkagePercentage": [

    ],
    "headCount": [

    ],
    "totalCount": 0,
    "usersDetail": [
      {
        "userName": "",
        "emailId": "",
        "reportingManagerName": "",
        "department": "",
        "team": "",
        "reportingManagerId": "",
        "dateMap": [

        ]
      },
    ]
  },

  uniqueTeams: [],
  uniqueManagers: [],
  uniqueHouse: [],

  selectedItem: { userId: "", approval: "0", leaveType: "0", date: "", comments: "" },
  // Define a generic action to update any property of selectedItem
  updateSelectedItem: (name, value) => set((state) => ({
    selectedItem: {
      ...state.selectedItem,
      [name]: value,
    },
  })),

  selectedFilter: { team: "", month: new Date().getMonth() + 1, year: new Date().getFullYear(), reportingManagerId: "", pageNumber: 1, pageSize: 20 },
  // Define a generic action to update any property of selectedItem
  updateSelectedFilter: (name, value) => set((state) => ({
    selectedFilter: {
      ...state.selectedFilter,
      [name]: value,
    },
  })),

  isLoading: false,
  setIsLoading: (bool) => set({ isLoading: bool }),

  isEditModalOpen: false,
  setEditModalToggle: () => set((state) => ({ isEditModalOpen: !state.isEditModalOpen })),


  fetchAttendanceFunc: async (setToaster, { month, year, team, reportingManagerIdsArray, pageSize, isFirstTime, pageNumber, house = 'In-house' }) => {
    try {
      set({ isLoading: true });
      const response = await getAttandance({ month, year, team, reportingManagerIdsArray, pageNumber, pageSize, house });
      set({ attendanceData: response.data });

      if (isFirstTime) {
        const teamAndRm = await getTeamAndRm(house);
        const teamsArray = teamAndRm.data.allTeamsInOurSystems.map(team => ({ value: team, label: team }));
        const houseArray = teamAndRm.data.allHouse.map(house => ({ value: house.value, label: house.value }));  // Adjusted here to use the 'value' field
        const reportingManagersArray = teamAndRm.data.allReportingManagersList.map(manager => ({ value: manager.reportingManagerUserId, label: manager.reportingManagerName }));

        // Added empty objects for selecting all.
        let newEmptyObject = { value: "", label: 'Select All' };
        reportingManagersArray.unshift(newEmptyObject);
        teamsArray.unshift(newEmptyObject);

        set({ uniqueTeams: teamsArray, uniqueManagers: reportingManagersArray, uniqueHouse: houseArray });
      }

    } catch (error) {
        setToaster("Error!!!", error.response.data.message, "danger");
    } finally {
        set({ isLoading: false });
    }
  },


  updateUserFunc: async (remarks, isLeaveApproved, setToaster) => {
    try {
      set({ isLoading: true });

      setToaster("Pending!!!", "This is pending task", "danger");
    } catch (error) {
      setToaster("Error!!!", error?.response?.data?.message, "danger");
    } finally {
      set({ isLoading: false });
    }
  },

}));

export const useLeaveBalancePageState = create((set, get) => ({
  leaveData: { "userId": "", "reportingManager": "", "shift": "", "currentStatus": "", "employeeLeaveBalanceId": "", "location": "", "leaveDetails": [] },

  isUserCheckedInData: { "isUserCheckedIn": false, "shiftStartTime": "", "shiftEndTime": "", "isWFH": false, "isOtherLocation": false },
  // Define a generic action to update any property of isUserCheckedInData
  updateIsUserCheckedInData: (name, value) => set((state) => ({
    isUserCheckedInData: {
      ...state.isUserCheckedInData,
      [name]: value,
    },
  })
  ),

  selectedLeave: "0",
  setSelectedLeave: (leaveId) => set({ selectedLeave: leaveId }),

  isLoading: false,
  setIsLoading: (bool) => set({ isLoading: bool }),

  isLeaveModalOpen: false,
  setLeaveModalToggle: () => set((state) => ({ isLeaveModalOpen: !state.isLeaveModalOpen })),

  isCheckInOutModalOpen: false,
  setCheckInOutModalToggle: () => set((state) => ({ isCheckInOutModalOpen: !state.isCheckInOutModalOpen })),

  fetchLeaveFunc: async (userId, setToaster) => {
    try {
      set({ isLoading: true });
      const response = await getLeave(userId);
      set({ leaveData: response.data });
    } catch (error) {
      setToaster("Error!!!", "Error while fetching Leave Data", "danger");
    } finally {
      set({ isLoading: false });
    }
  },

  getUserCheckedInStatusFunc: async (setToaster) => {
    try {
      set({ isLoading: true });
      let response = await getCheckInStatus();
      response = response.data;
      set({ isUserCheckedInData: { "isUserCheckedIn": response.isUserCheckedIn, "shiftStartTime": response.shiftStartTime, "shiftEndTime": response.shiftEndTime, "isWFH": response.isWFH, "isOtherLocation": response.isOtherLocationClockedIn } });
    } catch (error) {
      setToaster("Error!!!", "Error while fetching Leave Data", "danger");
    } finally {
      set({ isLoading: false });
    }
  },

  userCheckedInOutFunc: async (isWFH, isLoginRequest, isOtherLocation, setToaster) => {
    try {
      const state = get();

      set({ isLoading: true });

      const response = await userCheckedInOut({ isLoginRequest, "source": "WEB", isWFH });

      const { isUserCheckedInData } = get();
      set({
        isUserCheckedInData: {
        ...isUserCheckedInData,
        isUserCheckedIn: isLoginRequest,
        isOtherLocation,
      }
      });
      
      setTimeout(() => { state.setCheckInOutModalToggle() }, 500);

      setToaster("Success!!!", response.data.message, "success");
    } catch (error) {
      setToaster("Error!!!", error?.response?.data?.message, "danger");
    } finally {
      set({ isLoading: false });
    }
  },

}));

export const useApprovalsPageState = create((set, get) => ({
  approvalsData: {
    leaveRecord: [],
    totalCount: 0
  },

  myTeamDataArray: [],

  selectedApproval: "0",
  setSelectedApproval: (approvalId) => set({ selectedApproval: approvalId }),

  remarks: "",
  setRemarks: (comment) => set({ remarks: comment }),

  selectedFilter: { userId: "", leaveStatus: "", leaveMasterId: "", startDate: "", endDate: "", pageSize: "", pageNumber: "" },
  // Define a generic action to update any property of selectedItem
  updateSelectedFilter: (name, value) => set((state) => ({
    selectedFilter: {
      ...state.selectedFilter,
      [name]: value,
    },
  })),

  isLoading: false,
  setIsLoading: (bool) => set({ isLoading: bool }),

  isApprovalModalOpen: false,
  setApprovalModalToggle: () => set((state) => ({ isApprovalModalOpen: !state.isApprovalModalOpen })),

  fetchApprovalFunc: async (setToaster, { isFirstTime, userId, leaveStatus, startDate, endDate, leaveMasterId } = {}) => {
    try {
      set({ isLoading: true });
      const response = await getLeaveApprovals({ userId, leaveStatus, startDate, endDate, leaveMasterId });

      set({ approvalsData: response?.data });
      if (isFirstTime) {
        const teamAndRm = await getTeamAndRm();
        const teamAndRmArray = await teamAndRm.data?.myTeamEmployees?.map(team => ({ value: team.userId, label: team.userName }));
        // Addded empty objects for selecting all.
        let newEmptyObject = { value: "", label: 'All Users' };
        teamAndRmArray.unshift(newEmptyObject);
        set({ myTeamDataArray: teamAndRmArray });
      }
    } catch (error) {
      setToaster("Error!!!", error?.response?.data?.message, "danger");
    } finally {
      set({ isLoading: false });
    }
  },

  ApprovalLeaveActionFunc: async (ids, remarks, isLeaveApproved, setToaster) => {
    try {
        const state = get();
        set({ isLoading: true });

        // Ensure ids is an array
        if (!Array.isArray(ids)) {
            ids = [ids];
        }

        // Send the array of IDs to the backend
        const res = await approveOrRejectLeave(ids, { remarks, isLeaveApproved });
        setToaster("Success!!!", res.data.message, "success");

        const response = await getLeaveApprovals({ leaveStatus: state.selectedFilter.leaveStatus });
        set({ approvalsData: response.data });

    } catch (error) {
        setToaster("Error!!!", error.response.data.message, "danger");
    } finally {
        set({ isLoading: false });
    }
  },


}));
